export const getMaxOrderSection = [
  '',
  `query getMaxOrderSection {
    getMaxOrderSection
   }
`,
  'getMaxOrderSection'];
